import React, { Component } from 'react';
import { connect } from 'dva';
import Container from '../../../../components/Container';
import Iframe from '../../../../components/Iframe';

/**
 * 满意度结果查询
 */
@connect(({ user }) => ({
  ...user,
}))
export default class BaseResultQuery extends Component {
  render() {
    const { orgId } = this.props.currentUser;

    if (!orgId) {
      return null
    }

    const IframeDom = Iframe({
        src: `//rdp3.xiaoyuanhao.com/RDP-SERVER/rdppage/main/451026fe195d864e655a2319ac6e0f2f?orgId=${orgId || '330183-S000201'}`
      });

    return (
      <Container breStates defaultPadding>
        <IframeDom />
      </Container>
    );
  }
}
